
/* injects from baggage-loader */

'use strict';

import { findIndex, clone } from 'lodash';

import regions from './tab-book-reverso.const';

const initialState = {
    activeTab: 0,
    page: 0,
    pagination: 5 //limite de opções disponiveis na tela
};

export default class tabBookReversoController {
    constructor($log, $rootScope, $timeout) {
        'ngInject';
        this.$log = $log;
        this.$rootScope = $rootScope;
        this.$timeout = $timeout;
        
        this.state = clone(initialState);

        this.$rootScope.$on('setCurrentTabDevice', (event, data) => { 
            this.setCurrentTab(data);
        });
        
    }

    $onInit(){
        this.setRegion();

        this.$rootScope.$on('tabdevice:drop:success', angular.bind(this, this.onDropSuccess));
        this.$rootScope.$on('reset:stage', angular.bind(this, this.onReset));
    }

    setRegion(){
        this.tabs = regions[this.region].tabs;
        this.device = regions[this.region].device;
        this.book = regions[this.region].book;
        this.title = regions[this.region].title;
        this.description = regions[this.region].description;
        this.typeReg = regions[this.region].type;
    }
    
    getCurrentTab(){
        return this.tabs[this.state.activeTab];
    }

    setCurrentTab(index){
        this.state.activeTab = index;
        this.state.page = 0;
        if(this.typeReg === 1){
            //console.log(index);
            this.$rootScope.$emit('setCurrentTab',index);
        }
    }

    onDropSuccess(event, data){
        let indexOf = findIndex( this.getCurrentTab().items, { title: data.title })
        // select item dropped

        if(indexOf >= 0) {
            this.getCurrentTab().items[indexOf].selected = true;
        } else {
            return false;
        }
    }

    onReset(){
        this.state = clone(initialState);

        this.tabs.map( tab => {
            tab.items.map( item => {
                delete item.selected;
                return item;
            });
            return tab;
        });
    }

    togglePagination(){
        return this.state.page ? this.state.page = 0 : this.state.page = 1
    }

    
}


// WEBPACK FOOTER //
// ./src/app/components/ui/tab-book-reverso/tab-book-reverso.controller.js